<template>
    <div v-if="item">
        <div class="disclaimer-text-content">
            {{ item.Label }}
            <template v-if="item.LinkText && item.LinkUrl">
                <Link
                    v-if="showLink"
                    :href="item.LinkUrl"
                    :label="item.LinkText"
                    target="_blank"
                    class="link" />
                <ButtonLink v-else size="m" :onClick="toggleModal" class="link">
                    {{ item.LinkText }}
                </ButtonLink>
            </template>
        </div>

        <Modal v-if="item.LinkUrl && showModal" :onClose="toggleModal" size="xl">
            <Iframe :src="item.LinkUrl" :modal="true" :border="true" />
        </Modal>
    </div>
</template>

<script lang="ts">
    import { computed, defineComponent, PropType, ref } from 'vue';
    import { Disclaimer } from '@/api/Checkout/checkout.interfaces';
    import Modal from '@ui/components/Modal/Modal.vue';
    import Iframe from '@ui/components/Iframe/Iframe.vue';
    import ButtonLink from '@ui/components/Button/ButtonLink.vue';
    import { t } from '@shared/helpers/translation';
    import Link from '@ui/components/Link/Link.vue';
    import { disclaimersToRedirect } from '@/helpers/termsAndPoliciesLinks';

    export default defineComponent({
        name: 'DisclaimerText',
        methods: { t },
        components: { Link, ButtonLink, Iframe, Modal },
        props: {
            item: {
                type: Object as PropType<Disclaimer>,
                required: true,
            },
        },
        setup(props) {
            const showModal = ref(false);

            const showLink = computed(() => disclaimersToRedirect.includes(props.item.Id));

            function toggleModal() {
                showModal.value = !showModal.value;
            }

            return {
                showLink,
                showModal,
                toggleModal,
            };
        },
    });
</script>

<style lang="scss" scoped>
    @forward './DisclaimerText.scss';
</style>
